// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"5ce3f974","459":"32831e1c","787":"a1458409","879":"cb92410c"}[chunkId] + ".chunk.js";
};